module.exports = __webpack_public_path__ + "img/united_nations.fcf6200e.svg";